export const REVIEWED_AT = "2026-09-08";

/** Categories re-reviewed against their official sources after REVIEWED_AT. */
const CATEGORY_REVIEWED_AT: Record<string, string> = { ai: "2026-11-04", cloud: "2026-11-04", databases: "2026-11-04", embeddings: "2026-11-04", storage: "2026-11-04", queues: "2026-11-04" };
export const reviewedAtFor = (category: string) => CATEGORY_REVIEWED_AT[category] ?? REVIEWED_AT;
